import { AdminLayoutComponent, AuthLayoutComponent } from "./core";

import { Routes } from "@angular/router";
import { TemplatesComponent } from "./vengreso/templates/templates.component";
import { TempSharedShortcutComponent } from "./vengreso/shortcuts/temp-shared-shortcut/temp-shared-shortcut";
import { ShortcutsComponent } from "./vengreso/shortcuts/shortcuts.component";
import { ProfileComponent } from "./vengreso/profile/profile.component";
import { TemplatesResolver } from "./vengreso/templates/templates.resolver";
import { ShortcutCategoryListResolver } from "./vengreso/shortcuts/shortcut-category-list.resolver";
import { ShortcutListResolver } from "./vengreso/shortcuts/shortcut-list.resolver";
import { SettingsResolver } from "./vengreso/settings/settings.resolver";
import { AuthGuardService } from "./core/core-services/services/auth-guard.service";
import { ProfileResolver } from "./vengreso/profile/profile.resolver";
import { AdvancedSearchResultComponent } from "./vengreso/advanced-search-result/advanced-search-result.component";
import { SettingsComponent } from "./vengreso/settings/settings.component";
import { NewPlanComponent } from "./vengreso/settings/new-plan/new-plan.component";
import { PaymentDetailsComponent } from "./vengreso/settings/payment-details/payment-details.component";
import { PlansDetailsComponent } from "./vengreso/settings/plans/plans-details.component";
import { FlyLearningComponent } from "./vengreso/flylearning/fly-learning.component";
import { PaymentMethodDetailsComponent } from "./vengreso/settings/payment-method-details/payment-method-details.component";
import { AddPaymentMethodComponent } from "./vengreso/settings/payment-method-details/add-payment-method/add-payment-method.component";
import { BillingHistoryComponent } from "./vengreso/settings/billing-history/billing-history.component";
import { FlyCutInviteComponent } from "./vengreso/share/fly-cut-invite/fly-cut-invite.component";
import { FlyShareInviteGuardService } from "./core/core-services/services/flyshare-invite-guard.service";
import { FlyshareComponent } from "./vengreso/share/flyshare/flyshare.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { UserPersonaComponent } from "./vengreso/user-persona/user-persona.component";
import { UserPersonaAddComponent } from "./vengreso/user-persona-add/user-persona-add.component";
import { CanDeactivateFormGuard } from "./vengreso/user-persona-add/can-deactivate-form.guard";
import { MasqueradeHandlerComponent } from "./components/masquerade-handler/masquerade-handler.component";
import { MasqueradeGuardService } from "./core/core-services/guards/masquerade-guard.service";
import { ExternalRedirectGuard } from "./core/core-services/guards/admin-redirect.guard";
import { PricingEligibilityGuardService } from "./core/core-services/services/pricing-eligibility-guard.service";
import { environment } from "src/environments/environment";

export const AppRoutesMaintenance: Routes = [{ path: "**", component: MaintenanceComponent }];

export const AppRoutes: Routes = [
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
        resolve: {
          settings: SettingsResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "templates/:categoryId",
        component: TemplatesComponent,
        resolve: {
          templateList: TemplatesResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "flyplates/:categoryName",
        component: TemplatesComponent,
        resolve: {
          templateList: TemplatesResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "flyplates/:categoryName/:subCategoryName",
        component: TemplatesComponent,
        resolve: {
          templateList: TemplatesResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "flyplates/:categoryName/:subCategoryName/:subSubCategoryName",
        component: TemplatesComponent,
        resolve: {
          templateList: TemplatesResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "advanced-search-result",
        component: AdvancedSearchResultComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "shortcuts/:categoryId",
        component: ShortcutsComponent,
        resolve: {
          shortcutList: ShortcutListResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "shortcuts/:categoryId/:lv1CategoryId",
        component: ShortcutsComponent,
        resolve: {
          shortcutList: ShortcutListResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "shortcuts/:categoryId/:lv1CategoryId/:lv2CategoryId",
        component: ShortcutsComponent,
        resolve: {
          shortcutList: ShortcutListResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "settings",
        component: SettingsComponent,
        resolve: {
          settings: SettingsResolver,
          shortcutCategoryList: ShortcutCategoryListResolver,
        },
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateFormGuard],
      },
      {
        path: "plans", //this is deprecated just keep it in case any one using this url
        component: PlansDetailsComponent,
        canActivate: [AuthGuardService, PricingEligibilityGuardService],
      },
      {
        path: "flylearning",
        component: FlyLearningComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "pricing",
        component: PlansDetailsComponent,
        canActivate: [AuthGuardService, PricingEligibilityGuardService],
      },
      {
        path: "new-plan/:id",
        component: NewPlanComponent,
        canActivate: [AuthGuardService, PricingEligibilityGuardService],
      },
      {
        path: "payment-details/:id",
        component: PaymentDetailsComponent,
        canActivate: [AuthGuardService, PricingEligibilityGuardService],
      },
      {
        path: "payment-method-details",
        component: PaymentMethodDetailsComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "add-payment-method",
        component: AddPaymentMethodComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "billing-history",
        component: BillingHistoryComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "profile",
        component: ProfileComponent,
        resolve: {
          profile: ProfileResolver,
        },
        canActivate: [AuthGuardService],
      },
      {
        path: "persona",
        component: UserPersonaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "persona/new",
        component: UserPersonaAddComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateFormGuard],
      },
      {
        path: "persona/:userPersonaId",
        component: UserPersonaAddComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateFormGuard],
      },
      {
        path: "persona/:userPersonaId/duplicate",
        component: UserPersonaAddComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateFormGuard],
      },
      {
        path: "share/:flyshareId",
        component: FlyCutInviteComponent,
        canActivate: [FlyShareInviteGuardService],
      },
      {
        path: "flyshare/:id",
        component: FlyshareComponent,
        canActivate: [AuthGuardService],
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "masquerade",
        component: MasqueradeHandlerComponent,
        canActivate: [MasqueradeGuardService],
      },
      {
        path: "session",
        loadChildren: () => import("./session/session.module").then((m) => m.SessionModule),
      },
      {
        path: "shared-flycut/:key",
        component: TempSharedShortcutComponent,
      },
      {
        path: "onboardingprogress_training",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      // The legacy full-page onboarding wizard (src/app/onboarding/**) is
      // retired — its content (extension step, About You, signature) is now
      // part of the FlyBoard walk-me modal. These marketing-email URLs all
      // redirect to FlyBoard with that modal auto-opened; the step number is
      // deliberately ignored (see top-search-bar.component.ts's
      // checkIfIsOnboardingProgressTrainingUrl for the modal-open handling).
      {
        path: "onboarding",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding0",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding1",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding2",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding3",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding4",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding5",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding6",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding7",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding8",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "onboarding9",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
      {
        path: "retakeonboarding",
        redirectTo: "/flyboard?showonboardingprogresstraining=true",
      },
    ],
  },
  {
    path: "admin",
    canActivate: [ExternalRedirectGuard],
    data: { externalUrl: environment.ADMIN_APP_URL },
    children: [],
  },
  {
    path: "cmc",
    canActivate: [ExternalRedirectGuard],
    data: { externalUrl: environment.CMC_APP_URL },
    children: [],
  },
  {
    path: "roleplay",
    canActivate: [ExternalRedirectGuard],
    data: { externalUrl: environment.ROLEPLAY_APP_URL },
    children: [],
  },
  {
    path: "**",
    redirectTo: "session/404",
  },
];
